// Strain definitions for Canntycoon
// Each strain has full environmental optima, tolerances, risk profiles, and market appeal

export const STRAINS = {
  'bagseed-og': {
    id: 'bagseed-og',
    name: 'Bagseed OG',
    tier: 1,
    minLicense: 0,
    unlockCost: 0,
    unlockCostType: 'free',
    seedCost: 5,        // $ per seed
    description: 'Mystery genetics, but tough as nails. Forgiving for beginners.',
    genetics: 'indica',
    sprite: 'plant-mature',
    veg: {
      days: 21,
      tempOptimal: 24, tempTolerance: 4,
      humidityOptimal: 65, humidityTolerance: 12,
      vpdOptimal: 0.9, vpdTolerance: 0.4,
      co2Optimal: 700, co2Tolerance: 300,
      lightOptimal: 18, lightTolerance: 4,
    },
    flower: {
      days: 56,
      tempOptimal: 22, tempTolerance: 4,
      humidityOptimal: 50, humidityTolerance: 12,
      vpdOptimal: 1.2, vpdTolerance: 0.5,
      co2Optimal: 900, co2Tolerance: 400,
      lightOptimal: 12, lightTolerance: 2,
    },
    yieldCeiling: 45,       // grams per plant
    thcCeiling: 14,         // % THC at max quality
    cbdCeiling: 0.5,
    hermRisk: 0.08,         // low
    moldSusceptibility: 0.20,
    pestSusceptibility: 0.20,
    growthSpeed: 1.0,
    potencyMultiplier: 0.7,
    channelAppeal: { wholesale: 0.85, medical: 0.5, retail: 0.60, blackmarket: 0.65 },
    marketBasePrice: 1.80,  // $/g base before quality multipliers
  },

  'northern-lights': {
    id: 'northern-lights',
    name: 'Northern Lights',
    tier: 1,
    minLicense: 1,
    unlockCost: 500,
    unlockCostType: 'cash',
    seedCost: 15,
    description: 'A legendary indica. Resilient, high yield, dependable wholesale workhorse.',
    genetics: 'indica',
    sprite: 'plant-mature',
    veg: {
      days: 18,
      tempOptimal: 23, tempTolerance: 4,
      humidityOptimal: 60, humidityTolerance: 12,
      vpdOptimal: 0.9, vpdTolerance: 0.4,
      co2Optimal: 800, co2Tolerance: 300,
      lightOptimal: 18, lightTolerance: 4,
    },
    flower: {
      days: 49,
      tempOptimal: 21, tempTolerance: 4,
      humidityOptimal: 45, humidityTolerance: 10,
      vpdOptimal: 1.1, vpdTolerance: 0.45,
      co2Optimal: 1000, co2Tolerance: 400,
      lightOptimal: 12, lightTolerance: 2,
    },
    yieldCeiling: 78,      // +20% over Bagseed OG to justify unlock cost
    thcCeiling: 18,
    cbdCeiling: 0.4,
    hermRisk: 0.05,
    moldSusceptibility: 0.15,
    pestSusceptibility: 0.15,
    growthSpeed: 1.15,
    potencyMultiplier: 0.9,
    channelAppeal: { wholesale: 1.20, medical: 0.6, retail: 0.80, blackmarket: 0.70 },
    marketBasePrice: 2.20,
  },

  'cbd-harlequin': {
    id: 'cbd-harlequin',
    name: 'CBD Harlequin',
    tier: 1,
    minLicense: 1,
    unlockCost: 750,
    unlockCostType: 'cash',
    seedCost: 20,
    description: 'A sativa-dominant CBD strain. Medical buyers pay a premium. Low intoxication.',
    genetics: 'sativa',
    sprite: 'plant-mature',
    veg: {
      days: 22,
      tempOptimal: 25, tempTolerance: 3,
      humidityOptimal: 60, humidityTolerance: 10,
      vpdOptimal: 1.0, vpdTolerance: 0.35,
      co2Optimal: 750, co2Tolerance: 300,
      lightOptimal: 18, lightTolerance: 4,
    },
    flower: {
      days: 63,
      tempOptimal: 22, tempTolerance: 3,
      humidityOptimal: 48, humidityTolerance: 8,
      vpdOptimal: 1.2, vpdTolerance: 0.35,
      co2Optimal: 850, co2Tolerance: 350,
      lightOptimal: 12, lightTolerance: 2,
    },
    yieldCeiling: 50,
    thcCeiling: 7,
    cbdCeiling: 12,
    hermRisk: 0.06,
    moldSusceptibility: 0.22,
    pestSusceptibility: 0.18,
    growthSpeed: 0.90,
    potencyMultiplier: 0.6,
    channelAppeal: { wholesale: 0.70, medical: 1.30, retail: 0.55, blackmarket: 0.30 },
    marketBasePrice: 3.50,
  },

  'gorilla-glue-4': {
    id: 'gorilla-glue-4',
    name: 'Gorilla Glue #4',
    tier: 2,
    minLicense: 2,
    unlockCost: 2500,
    unlockCostType: 'cash',
    seedCost: 35,
    description: 'Extremely potent hybrid. Heavy resin production. Strong black market appeal.',
    genetics: 'hybrid-indica',
    sprite: 'plant-mature',
    veg: {
      days: 20,
      tempOptimal: 24, tempTolerance: 3,
      humidityOptimal: 60, humidityTolerance: 10,
      vpdOptimal: 1.0, vpdTolerance: 0.30,
      co2Optimal: 900, co2Tolerance: 300,
      lightOptimal: 18, lightTolerance: 3,
    },
    flower: {
      days: 63,
      tempOptimal: 21, tempTolerance: 3,
      humidityOptimal: 44, humidityTolerance: 8,
      vpdOptimal: 1.3, vpdTolerance: 0.30,
      co2Optimal: 1100, co2Tolerance: 400,
      lightOptimal: 12, lightTolerance: 2,
    },
    yieldCeiling: 58,
    thcCeiling: 28,
    cbdCeiling: 0.3,
    hermRisk: 0.14,         // moderate risk, watch your VPD
    moldSusceptibility: 0.28,
    pestSusceptibility: 0.22,
    growthSpeed: 0.95,
    potencyMultiplier: 1.3,
    channelAppeal: { wholesale: 0.85, medical: 0.45, retail: 1.15, blackmarket: 1.20 },
    marketBasePrice: 4.00,
  },

  'wedding-cake': {
    id: 'wedding-cake',
    name: 'Wedding Cake',
    tier: 2,
    minLicense: 2,
    unlockCost: 3000,
    unlockCostType: 'cash',
    seedCost: 45,
    description: 'Boutique terpene profile, beautiful buds. Premium retail gold.',
    genetics: 'hybrid-indica',
    sprite: 'plant-mature',
    veg: {
      days: 22,
      tempOptimal: 24, tempTolerance: 3,
      humidityOptimal: 58, humidityTolerance: 8,
      vpdOptimal: 1.0, vpdTolerance: 0.25,
      co2Optimal: 900, co2Tolerance: 300,
      lightOptimal: 18, lightTolerance: 3,
    },
    flower: {
      days: 63,
      tempOptimal: 20, tempTolerance: 2,  // tight late-flower temp for terpene expression
      humidityOptimal: 42, humidityTolerance: 7,
      vpdOptimal: 1.35, vpdTolerance: 0.25,
      co2Optimal: 1000, co2Tolerance: 350,
      lightOptimal: 12, lightTolerance: 2,
    },
    yieldCeiling: 52,
    thcCeiling: 24,
    cbdCeiling: 0.4,
    hermRisk: 0.18,
    moldSusceptibility: 0.30,
    pestSusceptibility: 0.25,
    growthSpeed: 0.92,
    potencyMultiplier: 1.1,
    channelAppeal: { wholesale: 0.75, medical: 0.60, retail: 1.30, blackmarket: 0.90 },
    marketBasePrice: 5.00,
  },

  'acdc': {
    id: 'acdc',
    name: 'ACDC',
    tier: 2,
    minLicense: 2,
    unlockCost: 2000,
    unlockCostType: 'cash',
    seedCost: 30,
    description: 'High-CBD medical strain. Low herm risk, compliance-friendly. Medical contracts love it.',
    genetics: 'hybrid',
    sprite: 'plant-mature',
    veg: {
      days: 20,
      tempOptimal: 24, tempTolerance: 4,
      humidityOptimal: 62, humidityTolerance: 12,
      vpdOptimal: 0.95, vpdTolerance: 0.4,
      co2Optimal: 800, co2Tolerance: 350,
      lightOptimal: 18, lightTolerance: 4,
    },
    flower: {
      days: 70,
      tempOptimal: 22, tempTolerance: 3,
      humidityOptimal: 48, humidityTolerance: 9,
      vpdOptimal: 1.2, vpdTolerance: 0.35,
      co2Optimal: 900, co2Tolerance: 400,
      lightOptimal: 12, lightTolerance: 2,
    },
    yieldCeiling: 55,
    thcCeiling: 6,
    cbdCeiling: 18,
    hermRisk: 0.03,         // very low
    moldSusceptibility: 0.18,
    pestSusceptibility: 0.20,
    growthSpeed: 0.88,
    potencyMultiplier: 0.5,
    channelAppeal: { wholesale: 0.65, medical: 1.40, retail: 0.60, blackmarket: 0.25 },
    marketBasePrice: 4.50,
  },

  'zkittlez': {
    id: 'zkittlez',
    name: 'Zkittlez',
    tier: 3,
    minLicense: 3,
    unlockCost: 200,
    unlockCostType: 'rp',
    seedCost: 60,
    description: 'Exotic fruity terpenes. Finicky grower — requires precise environment. Top-shelf retail only.',
    genetics: 'indica',
    sprite: 'plant-mature',
    veg: {
      days: 24,
      tempOptimal: 25, tempTolerance: 2,  // very tight
      humidityOptimal: 60, humidityTolerance: 7,
      vpdOptimal: 1.0, vpdTolerance: 0.20,
      co2Optimal: 950, co2Tolerance: 250,
      lightOptimal: 18, lightTolerance: 2,
    },
    flower: {
      days: 70,
      tempOptimal: 21, tempTolerance: 2,
      humidityOptimal: 44, humidityTolerance: 6,
      vpdOptimal: 1.3, vpdTolerance: 0.20,
      co2Optimal: 1100, co2Tolerance: 300,
      lightOptimal: 12, lightTolerance: 1,
    },
    yieldCeiling: 48,
    thcCeiling: 22,
    cbdCeiling: 0.5,
    hermRisk: 0.20,
    moldSusceptibility: 0.35,
    pestSusceptibility: 0.30,
    growthSpeed: 0.80,
    potencyMultiplier: 1.0,
    channelAppeal: { wholesale: 0.60, medical: 0.55, retail: 1.40, blackmarket: 1.00 },
    marketBasePrice: 6.50,
  },

  'ghost-train-haze': {
    id: 'ghost-train-haze',
    name: 'Ghost Train Haze',
    tier: 3,
    minLicense: 3,
    unlockCost: 350,
    unlockCostType: 'rp',
    seedCost: 75,
    description: 'One of the highest THC strains on record. Extreme sensitivity. Will attract regulatory eyes.',
    genetics: 'sativa',
    sprite: 'plant-mature',
    veg: {
      days: 25,
      tempOptimal: 26, tempTolerance: 2,
      humidityOptimal: 58, humidityTolerance: 7,
      vpdOptimal: 1.05, vpdTolerance: 0.18,
      co2Optimal: 1000, co2Tolerance: 200,
      lightOptimal: 18, lightTolerance: 2,
    },
    flower: {
      days: 84,           // very long flower time
      tempOptimal: 22, tempTolerance: 2,
      humidityOptimal: 42, humidityTolerance: 6,
      vpdOptimal: 1.4, vpdTolerance: 0.18,
      co2Optimal: 1200, co2Tolerance: 300,
      lightOptimal: 12, lightTolerance: 1,
    },
    yieldCeiling: 55,
    thcCeiling: 35,
    cbdCeiling: 0.2,
    hermRisk: 0.25,
    moldSusceptibility: 0.32,
    pestSusceptibility: 0.28,
    growthSpeed: 0.75,
    potencyMultiplier: 1.5,
    channelAppeal: { wholesale: 0.70, medical: 0.35, retail: 1.20, blackmarket: 1.40 },
    marketBasePrice: 7.00,
  },
};

export const STRAINS_LIST = Object.values(STRAINS);
export const getStrain = (id) => STRAINS[id];
